import _JSXStyle from "styled-jsx/style";
import React from 'react';
import Badge from "../Badge/Badge";
import Icon from "../Icon/Icon";

var ComboboxSelection = function ComboboxSelection(_ref) {
  var children = _ref.children,
      onRemove = _ref.onRemove;

  var handleRemoveClick = function handleRemoveClick(e) {
    e.stopPropagation();
    onRemove === null || onRemove === void 0 ? void 0 : onRemove();
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      onRemove === null || onRemove === void 0 ? void 0 : onRemove();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    role: "listitem",
    className: "jsx-2834078113" + " " + "mw-100"
  }, /*#__PURE__*/React.createElement(Badge, {
    tabIndex: 0,
    onClick: handleRemoveClick,
    onKeyDown: handleKeyDown,
    className: "selection d-flex flex-nowrap align-items-center m-1 user-select-none",
    color: "secondary",
    title: children,
    role: "button"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: '0',
      textTransform: 'none'
    },
    className: "jsx-2834078113" + " " + "me-2 text-truncate text-nowrap fw-normal"
  }, children), /*#__PURE__*/React.createElement(Icon, {
    ariaLabel: "Remove selection",
    className: "text-muted",
    name: "close"
  })), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2834078113"
  }, ".selection:focus{border-color:#80b7db;box-shadow:inset 0 1px 2px rgb(0 0 0 / 8%),0 0 0 0.25rem rgb(0 110 183 / 25%);outline:0;}"));
};

ComboboxSelection.displayName = "ComboboxSelection";
export default ComboboxSelection;